import moment from 'moment'

export const formatDateMoment = (date, format = 'DD/MM/YYYY') => {
    return date && moment(date).format(format)
}

export const diffDate = (date_start, date_end) => {
    date_start = new Date(date_start)
    date_end = new Date(date_end)

    return date_end - date_start
}

